import React from 'react';
import Button from '@material-ui/core/Button';
import Loader from 'views/admin/Common/Loader';
import useAppProvider from 'providers/useAppProvider';

const CustomButton = ({
  size = 'medium',
  type = 'button',
  loading = false,
  disabled = false,
  onClick = undefined,
  style = null,
  variant = 'contained',
  color = 'secondary',
  name = 'Save',
  className = '',
  fullWidth = false,
  showLoader = false,
}) => {
  const { buttonColor, buttonBorderColor, buttonLabelColor } = useAppProvider();
  return (
    <Button
      fullWidth={fullWidth}
      size={size}
      className={className}
      type={type}
      color={color !== 'secondary' || variant !== 'contained' ? color : 'default'}
      style={{
        fontWeight: 'bold',
        backgroundColor:
          !disabled && color === 'secondary' && variant === 'contained' && !buttonBorderColor
            ? buttonColor
            : !disabled && buttonBorderColor && color === 'secondary' && variant === 'contained'
            ? 'transparent'
            : '',
        color:
          !disabled && color === 'secondary' && variant === 'contained'
            ? buttonLabelColor
            : !disabled && color === 'secondary' && variant === 'contained'
            ? buttonLabelColor
            : '',
        border:
          !disabled && buttonBorderColor && color === 'secondary' && variant === 'contained'
            ? `2px solid ${buttonBorderColor}`
            : '',
        paddingBlock: !disabled && buttonBorderColor && color === 'secondary' && variant === 'contained' ? 4 : '',
        ...style,
      }}
      variant={variant}
      disabled={disabled}
      onClick={onClick}>
      {(type === 'submit' || showLoader) && loading ? <Loader /> : ''} <span>{name}</span>
    </Button>
  );
};

export default CustomButton;
